import { createGlobalStyle } from 'styled-components';

import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

export default createGlobalStyle`
  :root {
    --toastify-color-error: ${theme.colors.red.primary};
    --toastify-font-family: 'Inter';
    --toastify-toast-width: 360px;
  }

  .react-datepicker-wrapper {
    display: block;
  }

  .react-datepicker-popper {
    z-index: 10;;
  }

  .react-datepicker {
    border: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
    z-index: 10;

    font-family: 'Inter';
    font-style: normal;

    .react-datepicker__navigation {
      top: 10px;
    }

    .react-datepicker__header {
      border-bottom: 1px solid ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
      background-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};

      .react-datepicker__header__dropdown {
        .react-datepicker__year-dropdown-container {
          .react-datepicker__year-read-view--down-arrow {
            height: 6px;
            width: 6px;
            top: 5px;
            right: -10px;
            border-width: 1px 1px 0 0;
            border-color: ${theme.colors.gray.primary};
          }

          .react-datepicker__year-dropdown {
            border-color: ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
            background-color: ${theme.colors.white};

            .react-datepicker__year-option {
              .react-datepicker__navigation--years-upcoming {
                position: relative;

                &::before {
                  content: "";
                  position: absolute;
                  display: block;
                  border-color: #ccc;
                  border-style: solid;
                  border-width: 3px 3px 0 0;
                  height: 9px;
                  width: 9px;
                  top: 4px;
                  left: 11px;
                  transform: rotate(-45deg);
                }
              }

              .react-datepicker__navigation--years-previous {
                position: relative;

                &::before {
                  content: "";
                  position: absolute;
                  display: block;
                  border-color: #ccc;
                  border-style: solid;
                  border-width: 3px 3px 0 0;
                  height: 9px;
                  width: 9px;
                  top: 0;
                  left: 11px;
                  transform: rotate(-225deg);
                }
              }

              &:hover {
                background-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};

                .react-datepicker__navigation--years-upcoming {
                &::before {
                  border-color: #a6a6a6;
                }
              }
              }
            }
          }
        }
      }
    }

    .react-datepicker__day {
      &:hover {
        background-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
      }
    }

    .react-datepicker__day--selected {
      background-color: ${theme.colors.indigo.primary};

      &:hover {
        background-color: ${theme.colors.gray.secondary};
      }
    }

    .react-datepicker__day--selected.react-datepicker__day--today {
      background-color: ${theme.colors.indigo.primary};

      &:hover {
        background-color: ${theme.colors.gray.secondary};
      }
    }

    .react-datepicker__day--today {
      border-radius: 0.3rem;
      background-color: ${theme.colors.gray.secondary};
      color: ${theme.colors.white};

      &:hover {
        background-color: ${theme.colors.gray.secondary};
      }
    }

    .react-datepicker__month-text {
      &:hover {
        background-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
      }
    }

    .react-datepicker__month-text--selected {
      background-color: ${theme.colors.indigo.primary};
      color: ${theme.colors.white};

      &:hover {
        background-color: ${theme.colors.gray.secondary};
      }
    }

    .react-datepicker__month-text--selected.react-datepicker__month-text--today {
      background-color: ${theme.colors.indigo.primary};
      color: ${theme.colors.white};

      &:hover {
        background-color: ${theme.colors.gray.secondary};
      }
    }

    .react-datepicker__month-text--today {
      border-radius: 0.3rem;
      background-color: ${theme.colors.gray.secondary};
      color: ${theme.colors.white};

      &:hover {
        background-color: ${theme.colors.gray.secondary};
      }
    }

    .react-datepicker__year--container {
      .react-datepicker__year-wrapper {
        max-width: calc(192px + 0.8rem);

        .react-datepicker__year-text {
          &:hover {
            background-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
          }

          &.react-datepicker__year-text--selected {
            background-color: ${theme.colors.indigo.primary};

            &:hover {
              background-color: ${theme.colors.gray.secondary};
            }
          }

          &.react-datepicker__year-text--keyboard-selected {
            background-color: inherit;
          }
        }
      }
    }
  }

  .react-datepicker-popper[data-placement^=top] {
    .react-datepicker__triangle {
      &::before {
        border-top-color: ${hexToRGBA(theme.colors.gray.secondary, 0.16)};
      }
    }
  }

  .react-datepicker-popper[data-placement^=bottom] {
    .react-datepicker__triangle {
      &::before {
        border-bottom-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
      }

      &::after {
        border-bottom-color: transparent;
      }
    }
  }

  .animated-placeholder {
    position: relative;
    overflow: hidden;
    z-index: 1;
    
    &::after {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      background-image: linear-gradient(90deg, rgba(255,255,255,0) 46%, #fff 52%, rgba(255,255,255,0) 58%);
      background-size: 400% 100%;

      @keyframes skeleton-loading {
        from {
          background-position: 100% 50%;
        }
        to {
          background-position: 0 50%;
        }
      }

      animation: skeleton-loading 1.4s ease infinite;
    }
  }
`;
